import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import { StyledInlineChip } from './styles';
import { type InlineChipProps } from './types';

/** Compact coloured chip shown inline with text (message cards, composer chips). */
const InlineChip = t0 => {
  const $ = _c(10);
  let label;
  let leftIcon;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      label,
      color: t1,
      leftIcon,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = label;
    $[2] = leftIcon;
    $[3] = rest;
    $[4] = t1;
  } else {
    label = $[1];
    leftIcon = $[2];
    rest = $[3];
    t1 = $[4];
  }
  const color = t1 === undefined ? "precis-blue" : t1;
  let t2;
  if ($[5] !== color || $[6] !== label || $[7] !== leftIcon || $[8] !== rest) {
    t2 = <StyledInlineChip chipColor={color} {...rest}>{leftIcon}{label}</StyledInlineChip>;
    $[5] = color;
    $[6] = label;
    $[7] = leftIcon;
    $[8] = rest;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default InlineChip;
export { InlineChip };
export type { InlineChipProps } from './types';
export { INLINE_CHIP_COLORS, type InlineChipColor } from './styles';